module.exports = __webpack_public_path__ + "static/media/jinx.517e9d8d.png";